<template>
    <TheLayoutAuth title="Wachtwoord vergeten">
        <AppHeader>
            <AppTitle> Wachtwoord vergeten </AppTitle>
        </AppHeader>
        <AppArticle>
            Wachtwoord vergeten? Geen probleem! Voer hieronder je e-mailadres
            in, en als deze bekend is bij ons ontvang je direct een mail met een
            reset-link.
        </AppArticle>

        <AppAlert
            v-if="status"
            class="mt-4"
        >
            {{ status }}
        </AppAlert>

        <AppForm
            class="mt-4"
            @submit.prevent="submit"
        >
            <AppFormGroup>
                <AppFormInputText
                    v-model="form.email"
                    autofocus
                    required
                    :errors="form.errors.email"
                    label="Email"
                    name="email"
                    type="email"
                />
            </AppFormGroup>

            <AppFormFooter>
                <AppButtonGroup variant="spaced">
                    <AppLink
                        href="/login"
                        variant="back"
                        icon="arrow-back"
                    >
                        Terug naar inloggen
                    </AppLink>
                    <AppButton
                        color="primary"
                        :disabled="form.processing"
                        type="submit"
                    >
                        Verstuur Wachtwoord Reset link
                    </AppButton>
                </AppButtonGroup>
            </AppFormFooter>
        </AppForm>
    </TheLayoutAuth>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useForm } from "@inertiajs/vue3";
import TheLayoutAuth from "@/Layouts/TheLayoutAuth.vue";
import AppArticle from "@/Components/Shared/article/AppArticle.vue";
import AppAlert from "@/Components/Shared/alert/AppAlert.vue";
import AppForm from "@/Components/Shared/forms/AppForm.vue";
import AppFormGroup from "@/Components/Shared/forms/AppFormGroup.vue";
import AppFormInputText from "@/Components/Shared/forms/AppFormInputText.vue";
import AppFormFooter from "@/Components/Shared/forms/AppFormFooter.vue";
import AppButtonGroup from "@/Components/Shared/button/AppButtonGroup.vue";
import AppButton from "@/Components/Shared/button/AppButton.vue";
import AppHeader from "@/Components/Shared/header/AppHeader.vue";
import AppTitle from "@/Components/Shared/title/AppTitle.vue";
import AppLink from "@/Components/Shared/link/AppLink.vue";

export default defineComponent({
    components: {
        AppLink,
        AppTitle,
        AppHeader,
        AppButton,
        AppButtonGroup,
        AppFormFooter,
        AppFormInputText,
        AppFormGroup,
        AppForm,
        AppAlert,
        AppArticle,
        TheLayoutAuth,
    },
    props: {
        status: {
            type: String,
            default: "",
        },
    },
    setup() {
        const form = useForm({
            email: "",
        });

        // methods
        const submit = () => {
            form.post("/forgot-password");
        };

        return {
            form,
            submit,
        };
    },
});
</script>
